import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-card-box',
  templateUrl: './card-box.component.html',
  styleUrls: ['./card-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardBoxComponent implements OnInit {
  @Input() card: any;
  @Input() isHeader = true;
  @Input() isFooter = true;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/card-box/card-box.component.ts